export type ThemePreference = 'system' | 'light' | 'dark';

export const THEME_STORAGE_KEY = 'chronos-theme';

export function getThemePreference(): ThemePreference {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'system') {
      return stored;
    }
  } catch {
    /* private mode / blocked storage */
  }
  return 'system';
}

/**
 * Persist the preference and sync the document attribute.
 * System clears data-theme so CSS can follow prefers-color-scheme.
 */
export function setThemePreference(theme: ThemePreference): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* still apply for this session */
  }

  if (theme === 'system') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', theme);
  }
}
